import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function MobileFixedCTA() {
  const { t } = useTranslation();

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-airdoa-gray-light shadow-lg md:hidden">
      <div className="grid grid-cols-3">
        <Link
          to="/pricing"
          className="flex flex-col items-center justify-center py-3 gap-1 text-airdoa-navy hover:bg-airdoa-cream transition-colors duration-200"
        >
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-price-tag-3-line text-base" />
          </span>
          <span className="text-[10px] font-medium tracking-wide">{t("mobile.pricing")}</span>
        </Link>
        <Link
          to="/contact"
          className="flex flex-col items-center justify-center py-3 gap-1 bg-airdoa-gold text-airdoa-navy hover:bg-airdoa-gold-dark transition-colors duration-200"
        >
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-mail-line text-base" />
          </span>
          <span className="text-[10px] font-medium tracking-wide">{t("mobile.contact")}</span>
        </Link>
        <Link
          to="/gift"
          className="flex flex-col items-center justify-center py-3 gap-1 text-airdoa-navy hover:bg-airdoa-cream transition-colors duration-200"
        >
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-gift-line text-base" />
          </span>
          <span className="text-[10px] font-medium tracking-wide">{t("mobile.gift")}</span>
        </Link>
      </div>
    </div>
  );
}
